import { useState } from "react";
import { getCookie, handleLogOut } from "mmbclient/Common/CommonFunctions";


const SidebarMenuController = (store) => {

    const [sidebar, setSidebar] = useState(false);

    // State to track if the sidebar is expanded
    const [isExpanded, setIsExpanded] = useState(false);

    // Function to toggle the sidebar state
    const toggleSidebar = () => {
        setIsExpanded(prevState => !prevState);
    };

    const showSidebar = () => setSidebar(!sidebar);

    let logo = getCookie("__ss_us_");
    logo = (getCookie("__ss_us_") === '') ? "" : "/mmbclient/assets/img/" + logo + ".png";

    function showTrackingModalPage() {
        showSidebar();
        store.setTrackingModal(true);
    }

    function handleLog() {
        const confirmed = window.confirm('Are you sure you want to log out?');
        if (confirmed) {
            alert('You have been logged out.');
            // Add your logout logic here
            handleLogOut(store);
        } else {
            // alert('Logout canceled.');
        }
    }

    return { isExpanded, toggleSidebar, sidebar, logo, showSidebar, showTrackingModalPage, handleLog };
}

export default SidebarMenuController
